import script from "./AdminLogoutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLogoutModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminLogoutModal.vue?vue&type=style&index=0&id=4585f730&lang=css"

const __exports__ = script;

export default __exports__